import React, { Fragment } from 'react';
import { countryFlags } from '../../configs/countryFlags';
import {
  withSearch,
  WithSearchProps
} from '../../provider/SearchProvider/withSearch';
import { useFilterByCodeCountry } from '../../provider/Typo3Provider/hooks/useFilterByCodeCountry';
import {
  selectIsStaticContentLoaded,
  selectVehicleCentersMap
} from '../../provider/Typo3Provider/selectors';
import {
  withTypo3,
  WithTypo3Props
} from '../../provider/Typo3Provider/withTypo3';

interface LocationOptionsProps {
  noDefault?: boolean;
  filterByCodeCountry?: string;
}

const LocationOptions = ({
  search,
  typo3,
  noDefault,
  filterByCodeCountry = '',
  activeMarker
}: LocationOptionsProps & WithSearchProps & WithTypo3Props & {activeMarker?: String}) => {
  let options: JSX.Element | null = null;
  const locationCodes = useFilterByCodeCountry(filterByCodeCountry);
  if (selectIsStaticContentLoaded(typo3)) {
    // VehicleCenters from Typo3 are the single source of truth
    const vehicleCentersMap = selectVehicleCentersMap(typo3);
    const { locations, countryIdByLocationId } = search;
    options = (
      <Fragment key="options">
        {locationCodes.map(code => {
          const center = vehicleCentersMap.get(code);
          if (center) {
            return (
              <option value={code} key={code} selected={activeMarker === code}>
                {countryFlags.get(countryIdByLocationId.get(code) || '')} {locations[code]}
              </option>
            );
          }
          if (process.env.NODE_ENV !== 'production') {
            console.warn(`BzitLocationOptions: no center found! ('${code}')`);
          }
          // this should never happen!!!
          return null;
        })}
      </Fragment>
    );
  }
  return (
    <Fragment>
      {[
        noDefault ? null : (
          <option value="" key="empty">
            {typo3.translateTypo3(
              'form.placeholder.location',
              null,
              'Standort auswählen'
            )}
          </option>
        ),
        options
      ]}
    </Fragment>
  );
};

export default withTypo3(withSearch(LocationOptions));
